<template>
  <div class="tw-flex tw-flex-col tw-h-full tw-min-h-0">
    <div class="tw-flex tw-items-center tw-justify-between tw-mb-3 tw-shrink-0">
      <h3 class="tw-font-semibold tw-text-slate-700">
        I miei ticket ({{ items.length }})
      </h3>
      <button
        type="button"
        class="tw-text-xs tw-bg-fb-accent tw-text-white tw-rounded-lg tw-px-3 tw-py-1.5 hover:tw-bg-fb-accent-hover"
        @click="$emit('new')"
      >
        + Nuovo ticket
      </button>
    </div>

    <div
      class="tw-flex-1 tw-min-h-0 tw-overflow-y-auto tw-pr-1 tw-divide-y tw-divide-slate-100"
    >
      <p
        v-if="!items.length"
        class="tw-text-sm tw-text-slate-400 tw-text-center tw-py-8"
      >
        Nessun ticket. Apri la tua prima segnalazione con “Nuovo ticket”.
      </p>

      <button
        v-for="t in items"
        :key="t.id"
        type="button"
        class="tw-w-full tw-text-left tw-px-2 tw-py-2.5 tw-border-l-2 tw-transition hover:tw-bg-slate-50"
        :class="
          selectedId === t.id
            ? 'tw-border-fb-accent tw-bg-slate-50'
            : 'tw-border-transparent'
        "
        @click="$emit('select', t.id)"
      >
        <div class="tw-flex tw-items-center tw-justify-between tw-gap-2">
          <span
            class="tw-text-sm tw-font-medium tw-truncate tw-flex tw-items-center tw-gap-1.5"
          >
            <span
              v-if="t.unread"
              class="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-emerald-500 tw-shrink-0"
            ></span>
            {{ catMeta(t.category).icon }} {{ catMeta(t.category).label }}
          </span>
          <span
            class="tw-text-[11px] tw-shrink-0 tw-rounded-full tw-px-2 tw-py-0.5 tw-font-medium"
            :class="statusTone(t.status)"
          >
            {{ statusLabel(t.status, "user") }}
          </span>
        </div>
        <p class="tw-text-xs tw-text-slate-500 tw-mt-0.5 tw-line-clamp-1">
          <span v-if="t.latestMessage" class="tw-text-slate-400">
            {{ t.latestMessage.senderType === "user" ? "Tu: " : "Team: " }}
          </span>
          {{ t.latestMessage ? t.latestMessage.body : t.preview }}
        </p>
        <div class="tw-flex tw-items-center tw-justify-between tw-mt-0.5">
          <span class="tw-text-[11px] tw-text-slate-400">
            {{ formatDate(t.lastMessageAt || t.createdAt) }}
          </span>
          <span
            v-if="t.unread"
            class="tw-text-[11px] tw-font-medium tw-text-emerald-600"
          >
            nuova risposta
          </span>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import {
  categoryMeta,
  statusLabel,
  statusTone,
} from "../services/feedbackService";

export default {
  name: "FeedbackTicketList",
  props: {
    items: { type: Array, default: () => [] },
    selectedId: { type: [Number, String], default: null },
  },
  emits: ["select", "new"],
  methods: {
    catMeta(v) {
      return categoryMeta(v);
    },
    statusLabel,
    statusTone,
    formatDate(d) {
      try {
        return new Date(d).toLocaleString("it-IT");
      } catch {
        return "";
      }
    },
  },
};
</script>
